import { render, staticRenderFns } from "./PortfolioWork.vue?vue&type=template&id=f499321c&"
import script from "./PortfolioWork.vue?vue&type=script&lang=js&"
export * from "./PortfolioWork.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioWork.vue?vue&type=style&index=0&id=f499321c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports